"use strict";
/* eslint-disable max-len */
const util = require('util');
/**
 * @deprecated getAttrCampaignFirst() is deprecated from totango-utils. Use getAttrCampaignFirst imported from @totango-app-team/totango-campaigns instead.
 */
const getAttrCampaignFirst = util.deprecate((campaignId) => `campaign_${campaignId}_first`, 'getAttrCampaignFirst() is deprecated from totango-utils. Use getAttrCampaignFirst imported from @totango-app-team/totango-campaigns instead');
/**
 * @deprecated getAttrCampaignLast() is deprecated from totango-utils. Use getAttrCampaignLast imported from @totango-app-team/totango-campaigns instead.
 */
const getAttrCampaignLast = util.deprecate((campaignId) => `campaign_${campaignId}_last`, 'getAttrCampaignLast() is deprecated from totango-utils. Use getAttrCampaignLast imported from @totango-app-team/totango-campaigns instead');
/**
 * @deprecated getAttrCampaignDedupe() is deprecated from totango-utils. Use getAttrCampaignDedupe imported from @totango-app-team/totango-campaigns instead.
 */
const getAttrCampaignDedupe = util.deprecate((campaignId) => `campaign_${campaignId}_deduped`, 'getAttrCampaignDedupe() is deprecated from totango-utils. Use getAttrCampaignDedupe imported from @totango-app-team/totango-campaigns instead');
/**
 * @deprecated getAttrCampaignEmailSent() is deprecated from totango-utils. Use getAttrCampaignEmailSent imported from @totango-app-team/totango-campaigns instead.
 */
const getAttrCampaignEmailSent = util.deprecate((campaignId) => `campaign_${campaignId}_email_sent`, 'getAttrCampaignEmailSent() is deprecated from totango-utils. Use getAttrCampaignEmailSent imported from @totango-app-team/totango-campaigns instead');
/**
 * @deprecated campaignUnsubscribe is deprecated from totango-utils. Use campaignUnsubscribe imported from @totango-app-team/totango-campaigns instead.
 */
const campaignUnsubscribe = 'campaign_unsubscribe';
/**
 * @deprecated marketingUnsubscribe is deprecated from totango-utils. Use marketingUnsubscribe imported from @totango-app-team/totango-campaigns instead.
 */
const marketingUnsubscribe = 'Marketing Unsubscribe';
module.exports = {
    getAttrCampaignFirst,
    getAttrCampaignLast,
    getAttrCampaignDedupe,
    getAttrCampaignEmailSent,
    campaignUnsubscribe,
    marketingUnsubscribe,
};
//# sourceMappingURL=attributesKeys.js.map